module.exports = __webpack_public_path__ + "img/icon-flag-uk-green.ea65fa3a.svg";